import type { SideQuestsMarker } from "@/types/quest";
import type { TileCoordinates } from "@/types/tile";
import { QuestObjectiveActions } from "./quest_objective_actions";

export const sideQuestsMarkers = new Map<number, SideQuestsMarker>([
	[
		5001,
		{
			markerCoordinates: { x: 526, y: 497 },
			prerequisites: {
				action: QuestObjectiveActions.HAVE_SPECIFIC_SETTLEMENT_ON_LEVEL,
				settlement_id: 1,
				amount: 7,
			},
		},
	],
	[
		5002,
		{
			markerCoordinates: { x: 526, y: 497 },
			prerequisites: {
				action: QuestObjectiveActions.FINISH_QUEST,
				quest_id: 5001,
				amount: 1,
			},
		},
	],
	[
		5003,
		{
			markerCoordinates: { x: 526, y: 497 },
			prerequisites: {
				action: QuestObjectiveActions.FINISH_QUEST,
				quest_id: 5002,
				amount: 1,
			},
		},
	],
	[
		5004,
		{
			markerCoordinates: { x: 526, y: 497 },
			prerequisites: {
				action: QuestObjectiveActions.FINISH_QUEST,
				quest_id: 5003,
				amount: 1,
			},
		},
	],
	[
		5005,
		{
			markerCoordinates: { x: 526, y: 497 },
			prerequisites: {
				action: QuestObjectiveActions.FINISH_QUEST,
				quest_id: 5004,
				amount: 1,
			},
		},
	],
	// Questline: Echoes of Pestilence
	[
		5006,
		{
			markerCoordinates: { x: 507, y: 517 },
			prerequisites: {
				action: QuestObjectiveActions.HAVE_SPECIFIC_SETTLEMENT_ON_LEVEL,
				settlement_id: 1,
				amount: 10,
			},
		},
	],
	[
		5007,
		{
			markerCoordinates: { x: 507, y: 517 },
			prerequisites: {
				action: QuestObjectiveActions.FINISH_QUEST,
				quest_id: 5006,
				amount: 1,
			},
		},
	],
	[
		5008,
		{
			markerCoordinates: { x: 507, y: 517 },
			prerequisites: {
				action: QuestObjectiveActions.FINISH_QUEST,
				quest_id: 5007,
				amount: 1,
			},
		},
	],
	[
		5009,
		{
			markerCoordinates: { x: 507, y: 517 },
			prerequisites: {
				action: QuestObjectiveActions.FINISH_QUEST,
				quest_id: 5008,
				amount: 1,
			},
		},
	],
	[
		5010,
		{
			markerCoordinates: { x: 507, y: 517 },
			prerequisites: {
				action: QuestObjectiveActions.FINISH_QUEST,
				quest_id: 5009,
				amount: 1,
			},
		},
	],
	[
		5011,
		{
			markerCoordinates: { x: 507, y: 517 },
			prerequisites: {
				action: QuestObjectiveActions.FINISH_QUEST,
				quest_id: 5010,
				amount: 1,
			},
		},
	],
	// Questline: A Nice Day for Fishing
	[
		5012,
		{
			markerCoordinates: { x: 473, y: 515 },
			prerequisites: {
				action: QuestObjectiveActions.HAVE_SPECIFIC_SETTLEMENT_ON_LEVEL,
				settlement_id: 1,
				amount: 15,
			},
		},
	],
	[
		5013,
		{
			markerCoordinates: { x: 473, y: 515 },
			prerequisites: {
				action: QuestObjectiveActions.FINISH_QUEST,
				quest_id: 5012,
				amount: 1,
			},
		},
	],
	[
		5014,
		{
			markerCoordinates: { x: 473, y: 515 },
			prerequisites: {
				action: QuestObjectiveActions.FINISH_QUEST,
				quest_id: 5013,
				amount: 1,
			},
		},
	],
	[
		5015,
		{
			markerCoordinates: { x: 473, y: 515 },
			prerequisites: {
				action: QuestObjectiveActions.FINISH_QUEST,
				quest_id: 5014,
				amount: 1,
			},
		},
	],
	[
		5016,
		{
			markerCoordinates: { x: 473, y: 515 },
			prerequisites: {
				action: QuestObjectiveActions.FINISH_QUEST,
				quest_id: 5015,
				amount: 1,
			},
		},
	],
	// Questline: Iron Mines
	[
		5017,
		{
			markerCoordinates: { x: 499, y: 468 },
			prerequisites: {
				action: QuestObjectiveActions.HAVE_SPECIFIC_SETTLEMENT_ON_LEVEL,
				settlement_id: 1,
				amount: 19,
			},
		},
	],
	[
		5018,
		{
			markerCoordinates: { x: 499, y: 468 },
			prerequisites: {
				action: QuestObjectiveActions.FINISH_QUEST,
				quest_id: 5017,
				amount: 1,
			},
		},
	],
	[
		5019,
		{
			markerCoordinates: { x: 499, y: 468 },
			prerequisites: {
				action: QuestObjectiveActions.FINISH_QUEST,
				quest_id: 5018,
				amount: 1,
			},
		},
	],
	[
		5020,
		{
			markerCoordinates: { x: 499, y: 468 },
			prerequisites: {
				action: QuestObjectiveActions.FINISH_QUEST,
				quest_id: 5019,
				amount: 1,
			},
		},
	],
	// Questline: Goods for the Good Men
	[
		5021,
		{
			markerCoordinates: { x: 523, y: 563 },
			prerequisites: {
				action: QuestObjectiveActions.HAVE_SPECIFIC_SETTLEMENT_ON_LEVEL,
				settlement_id: 1,
				amount: 24,
			},
		},
	],
	[
		5022,
		{
			markerCoordinates: { x: 523, y: 563 },
			prerequisites: {
				action: QuestObjectiveActions.FINISH_QUEST,
				quest_id: 5021,
				amount: 1,
			},
		},
	],
	[
		5023,
		{
			markerCoordinates: { x: 523, y: 563 },
			prerequisites: {
				action: QuestObjectiveActions.FINISH_QUEST,
				quest_id: 5022,
				amount: 1,
			},
		},
	],
	[
		5024,
		{
			markerCoordinates: { x: 523, y: 563 },
			prerequisites: {
				action: QuestObjectiveActions.FINISH_QUEST,
				quest_id: 5023,
				amount: 1,
			},
		},
	],
	[
		5025,
		{
			markerCoordinates: { x: 523, y: 563 },
			prerequisites: {
				action: QuestObjectiveActions.FINISH_QUEST,
				quest_id: 5024,
				amount: 1,
			},
		},
	],
	[
		5026,
		{
			markerCoordinates: { x: 523, y: 563 },
			prerequisites: {
				action: QuestObjectiveActions.FINISH_QUEST,
				quest_id: 5025,
				amount: 1,
			},
		},
	],
	[
		5027,
		{
			markerCoordinates: { x: 523, y: 563 },
			prerequisites: {
				action: QuestObjectiveActions.FINISH_QUEST,
				quest_id: 5026,
				amount: 1,
			},
		},
	],
	[
		5028,
		{
			markerCoordinates: { x: 523, y: 563 },
			prerequisites: {
				action: QuestObjectiveActions.FINISH_QUEST,
				quest_id: 5027,
				amount: 1,
			},
		},
	],
]);

export const getQuestIdsByCoordinates = (
	coordinates: TileCoordinates,
): number[] => {
	const questIds: number[] = [];
	for (const [questId, marker] of sideQuestsMarkers.entries()) {
		if (
			marker.markerCoordinates.x === coordinates.x &&
			marker.markerCoordinates.y === coordinates.y
		) {
			questIds.push(questId);
		}
	}
	return questIds;
};
